import { createSlice } from "@reduxjs/toolkit";

/**
 * App-level clipboard for copy/paste of documents between matters
 * (Matthew, 2026-07-20). Copy fills it from any matter's tree; Paste in
 * a folder context menu posts /documents/copy/ with the target. The
 * clipboard deliberately survives matter navigation (that's the whole
 * point) and repeated pastes (like an OS clipboard) — it only clears on
 * explicit Clear or a fresh Copy.
 */
const DocumentClipboardSlice = createSlice({
  name: "documentClipboard",
  initialState: { items: [], sourceMatterId: null },
  reducers: {
    copyDocumentsToClipboard: (state, action) => {
      const { items, sourceMatterId } = action.payload || {};
      state.items = Array.isArray(items)
        ? items.filter((i) => i && i.id)
        : [];
      state.sourceMatterId = sourceMatterId ?? null;
    },
    clearDocumentClipboard: (state) => {
      state.items = [];
      state.sourceMatterId = null;
    },
  },
});

export const { copyDocumentsToClipboard, clearDocumentClipboard } =
  DocumentClipboardSlice.actions;

const EMPTY_CLIPBOARD_ITEMS = [];

export const selectClipboardItems = (state) =>
  state.documentClipboard?.items || EMPTY_CLIPBOARD_ITEMS;
export const selectClipboardCount = (state) =>
  state.documentClipboard?.items?.length || 0;

export default DocumentClipboardSlice.reducer;
